import { render } from "./paneladd.vue?vue&type=template&id=9bd046f2"
import script from "./paneladd.vue?vue&type=script&lang=js"
export * from "./paneladd.vue?vue&type=script&lang=js"

import "./paneladd.vue?vue&type=style&index=0&id=9bd046f2&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__